import { Link, useLocation } from 'react-router-dom';
import { faPhone, faBox, faPhoneVolume } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import 'styles/nav.css';
import React from 'react';

const Navbar: React.FC = () => {
    const location = useLocation();

    const isActive = (path: string) => {
        return location.pathname === path || location.pathname.startsWith(path + '/');
    };

    return (
        <nav className="navbar">
            <Link to="/" className="logo">
                <FontAwesomeIcon className="img" icon={faPhone}></FontAwesomeIcon>
            </Link>
            <ul>
                <li>
                    <Link to="/" className={isActive('/') && location.pathname === '/' ? 'active' : ''}>
                        <FontAwesomeIcon icon={faPhoneVolume}></FontAwesomeIcon>
                        <span>Appels rendez-vous</span>
                    </Link>
                </li>
                <li>
                    <Link to="/part-orders" className={isActive('/part-orders') ? 'active' : ''}>
                        <FontAwesomeIcon icon={faBox}></FontAwesomeIcon>
                        <span>Commandes de pièces</span>
                    </Link>
                </li>
            </ul>
        </nav>
    )
}

export default Navbar
